import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PersonModel} from '../../../models/people/people.model';
import {PeopleService} from '../../../routes/people/people.service';
import 'rxjs/add/operator/take';

@Component({
  selector: 'user-popup',
  templateUrl: './user-popup.component.html',
  styleUrls: ['./user-popup.component.less']
})
export class UserPopupComponent implements OnInit {

  @Input('userId') personId;
  @Output('close') close = new EventEmitter();

  person: PersonModel;

  constructor(private peopleService: PeopleService) {

  }

  ngOnInit() {
    this.peopleService.getPeopleReportModel(this.personId).take(1).subscribe(res => {
      this.person = res;
    });

  }

  onClose() {
    this.close.next();
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/components/user-popup/user-popup.component.ts